import { Nullable } from "@ctra/utils";

export interface SavedChartsResponse {
  userId: string;
  pages: Record<string, Array<Group>>;
}

/**
 * @todo if we end up with more type of display filters, add them here
 * @todo rename to DisaplyFilter when V2 is killed
 */
export interface V3DisplayFilter {
  type: "series";
  values: Array<string>;
}

export interface Filter {
  type: FilterConfig;
  values: Array<string | number>;
}

export type SavedChart = {
  variantId: string;
  chartType: string;
  dateRange: Nullable<Array<string>>;
  displayFilters?: Array<V3DisplayFilter>;
  dataFilters?: Array<Filter>;
};

export type SavedChartsPayload = Array<SavedChart>;

export interface Group {
  groupName: string;
  charts: SavedChartsPayload;
}

export enum FilterConfig {
  dimGroup = "dimGroup",
  herdGroup = "herdGroup",
  penName = "penName"
}

export type SavedChartState = {
  timePeriod?: {
    startDate: string;
    endDate: string;
  };
  isoDuration: Nullable<string>;
  dataFilters?: Array<Filter>;
  displayFilters?: Array<V3DisplayFilter>;
  view: string;
};

export type SavedChartList = Array<Group>;
export type SavedCharts = Record<string, SavedChartList>;
